<template lang="pug">
.root
  .loading
    i.mdi.mdi-loading.mdi-spin
</template>

<script>

export default {
  methods: {
    /**
     * Create a shopify connection based on URL params
     */
    async createShopifyConnection() {
      const params = new URLSearchParams(window.location.search);

      const paramsObj = {};
      // eslint-disable-next-line
      for (const [key, value] of params) {
        paramsObj[key] = value;
      }

      const ok = await this.$store.dispatch('Oauth/createShopifyConnection', paramsObj);
      if (!ok) {
        await swal({ title: this.$t('errors.error_occured'), text: this.$t('settings.shopify.validation-error'), icon: 'error' });
      }

      await this.$store.dispatch('AccountManager/getShoppingSettings');

      this.$router.push('/settings/liveshopping');
    },
  },
  mounted() {
    this.createShopifyConnection();
  },
};
</script>

<style lang="scss" scoped>
.loading {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
  text-align: center;
  i {
    color: rgba(44, 62, 79, .5);
    font-size: 6rem;
  }
}
</style>
